import { Button, ButtonGroup, LegacyStack, Text } from '@shopify/polaris';
import { useContext, useEffect, useState } from 'react';
import ToastContext from '../../../context/ToastContext';
import { SET_ERROR, SET_OK } from '../../../context/ToastReducer';
import { postDeliveryAllStockById, postDeliveryStatus } from '../../../services/deliveriesService';
import DropdownButton from '../Common/DropdownButton';
import { PDFModal } from '../Modals/PDFModal';

const ViewDeliveriesPrimaryActions = ({ delivery, status, id, onToggleState, onAcceptAll }) => {
  const [, dispatchToast] = useContext(ToastContext);

  const [activePDFModal, setActivePDFModal] = useState(false);
  const [queryPDF, setQueryPDF] = useState({
    deliveryId: id,
  });

  const handleToggleState = () => {
    const message =
      status === 'OPEN'
        ? 'Al cerrar el envío se bloquea la posiblidad de añadir más mercancía de este envío al almacén. Cierrelo una vez haya terminado de añadir la mercancía.\n\n¿Desea continuar?'
        : 'La reapertura de un envío permite añadir mercancía al almacén y puede generar insonsitencias no deseadas. Utilice esta acción con cuidado.\n\n¿Desea continuar?';
    window.confirm(message) &&
      postDeliveryStatus(id, status === 'OPEN' ? 'CLOSE' : 'OPEN')
        .then((r) => {
          dispatchToast({ type: SET_OK, payload: { message: r.data.message } });
          onToggleState({
            newState: r.data.status,
          });
        })
        .catch((e) => {
          dispatchToast({ type: SET_ERROR, payload: e.response.data });
        });
  };

  const handleOnAcceptAll = () =>
    window.confirm(
      'Al aceptar toda la mercancía, se añaden al almacén todos los artículos y se cierra el envío.\n\n¿Desea continuar?',
    ) &&
    postDeliveryAllStockById(id)
      .then((r) => {
        dispatchToast({ type: SET_OK, payload: { message: r.data.message } });
        onAcceptAll();
      })
      .catch((e) => {
        dispatchToast({ type: SET_ERROR, payload: e.response.data });
      });

  const handlePDFExport = () => {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);

    //Transform urlParams to object queryPDF
    const q = {};
    for (const [key, value] of urlParams) {
      q[key] = value;
    }
    delete q['r'];

    setQueryPDF({ ...queryPDF, ...q });
    setActivePDFModal(true);
  };

  const dropdownItems =
    status === 'OPEN'
      ? [
          {
            content: 'Aceptar toda la mercancía',
            onAction: () => handleOnAcceptAll(),
            disabled: !delivery || !delivery.deposit || !delivery.deposit.id,
          },
          {
            content: 'Cerrar Envío',
            onAction: () => handleToggleState(),
            disabled: !delivery || !delivery.deposit || !delivery.deposit.id,
          },
        ]
      : [
          {
            content: 'Reabrir Envío',
            onAction: () => handleToggleState(),
          },
        ];

  const dropdownItems2 = [
    {
      content: 'Exportar a PDF',
      disabled: !delivery || !delivery.deposit || !delivery.deposit.id,
      onAction: handlePDFExport,
    },
    {
      content: 'Exportar a CSV',
      disabled: true,
    },
  ];

  return (
    <LegacyStack>
      <DropdownButton
        title={'Exportar'}
        items={dropdownItems2}
        buttonProps={{ disabled: dropdownItems2.reduce((acc, cur) => acc && cur.disabled, true) }}
      />
      <DropdownButton
        title={'Acciones'}
        items={dropdownItems}
        buttonProps={{ disabled: dropdownItems.reduce((acc, cur) => acc && cur.disabled, true) }}
      />
      <PDFModal
        title={'RECEPCIÓN DE MERCANCÍA'}
        subtitle={delivery && delivery.deposit ? delivery.name + ' | ' + delivery.deposit.name : null}
        active={activePDFModal}
        onClose={() => setActivePDFModal(false)}
        domain={'deliveries'}
        model={'stock'}
        query={queryPDF}
        attributesDefault={{
          cover: true,
          showNumbers: true,
          empty: false,
          blink: false,
        }}
        AttributesWrapper={PDFAttributes}
      />
    </LegacyStack>
  );
};

const PDFAttributes = ({ attr, onAttrChange = () => {} }) => {
  const [attributes, setAttributes] = useState(attr);
  const [optionSelected, setOptionSelected] = useState('0');

  const handleOptionChange = (selected) => {
    setOptionSelected(selected);

    switch (selected) {
      case '0':
        setAttributes({ ...attr, showNumbers: true, empty: false, blink: false });
        break;
      case '1':
        setAttributes({ ...attr, showNumbers: false, empty: true, blink: false });
        break;
      case '2':
        setAttributes({ ...attr, showNumbers: false, empty: true, blink: true });
        break;
      default:
        break;
    }
  };

  useEffect(() => {
    handleOptionChange('0');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    onAttrChange(attributes);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [attributes]);

  return (
    <>
      <LegacyStack spacing="loose">
        <LegacyStack.Item>
          <>
            <Text variant="bodyMd">Propiedades</Text>
            <Button
              primary={attributes.cover}
              onClick={(e) =>
                setAttributes({
                  ...attributes,
                  cover: !attributes.cover,
                })
              }
            >
              Incluir portada
            </Button>
          </>
        </LegacyStack.Item>
        <LegacyStack.Item>
          <Text variant="bodyMd">Tipo de tabla</Text>
          <ButtonGroup segmented>
            <Button onClick={() => handleOptionChange('0')} primary={optionSelected === '0'}>
              Resumen
            </Button>
            <Button onClick={() => handleOptionChange('1')} primary={optionSelected === '1'}>
              Revisión
            </Button>
            <Button onClick={() => handleOptionChange('2')} primary={optionSelected === '2'}>
              Ciego
            </Button>
          </ButtonGroup>
        </LegacyStack.Item>
      </LegacyStack>
    </>
  );
};

export default ViewDeliveriesPrimaryActions;
